// extracted by mini-css-extract-plugin
export default {"captionOverlay":"web_captionOverlay__N7YYo","captionAnimation":"web_captionAnimation__q1j56","shine":"web_shine__Sr1q9"};